/* VT: Streamline-style desktop nav behaviour.
   Ported from the vipvape.ca Streamline theme (theme.js hoverMenu +
   vv-desktop-nav-hover.js debounce), merged into one clean module.

   - Opens <details data-hover="true"> on hover with a 180ms debounced
     close so the menu doesn't flicker on item boundaries.
   - Summary click navigates to the parent link (parents are real pages).
   - Keyboard: focus opens, focusout closes, Escape closes everything.
   - Idempotent; rebinds on shopify:section:load for the theme editor. */
(function () {
  'use strict';

  var mq = window.matchMedia('(min-width: 750px)');
  var CLOSE_DELAY = 180;
  var timers = new WeakMap();
  var bound = new WeakSet();
  var SELECTOR = '.vt-site-nav-wrap details[data-hover="true"]';

  function summaryOf(detail) {
    return detail.querySelector(':scope > summary');
  }

  function setOpen(detail, isOpen) {
    var summary = summaryOf(detail);
    if (isOpen) {
      detail.setAttribute('open', '');
      if (summary) summary.setAttribute('aria-expanded', 'true');
    } else {
      detail.removeAttribute('open');
      if (summary) summary.setAttribute('aria-expanded', 'false');
    }
  }

  function clearCloseTimer(detail) {
    var t = timers.get(detail);
    if (t) {
      clearTimeout(t);
      timers.delete(detail);
    }
  }

  function scheduleClose(detail) {
    clearCloseTimer(detail);
    timers.set(
      detail,
      setTimeout(function () {
        timers.delete(detail);
        if (detail.matches(':hover') || detail.matches(':focus-within')) return;
        setOpen(detail, false);
        // Also close any nested details left open inside this one.
        detail.querySelectorAll('details[open]').forEach(function (nested) {
          setOpen(nested, false);
        });
      }, CLOSE_DELAY)
    );
  }

  function bind(detail) {
    if (bound.has(detail)) return;
    bound.add(detail);

    var summary = summaryOf(detail);

    if (summary) {
      summary.addEventListener('click', function (event) {
        event.preventDefault();
        var link = summary.dataset.link;
        if (link) window.location.href = link;
      });
    }

    detail.addEventListener('mouseenter', function () {
      if (!mq.matches) return;
      clearCloseTimer(detail);
      setOpen(detail, true);
    });

    detail.addEventListener('mouseover', function () {
      if (!mq.matches) return;
      clearCloseTimer(detail);
      if (!detail.hasAttribute('open')) setOpen(detail, true);
    });

    detail.addEventListener('mouseleave', function () {
      if (!mq.matches) return;
      scheduleClose(detail);
    });

    detail.addEventListener('focusin', function () {
      if (!detail.hasAttribute('open')) setOpen(detail, true);
    });

    detail.addEventListener('focusout', function () {
      // Wait a tick so :focus-within reflects the new focus target.
      requestAnimationFrame(function () {
        if (detail.hasAttribute('open') && !detail.matches(':focus-within')) {
          setOpen(detail, false);
        }
      });
    });
  }

  function closeAll() {
    document.querySelectorAll(SELECTOR + '[open]').forEach(function (detail) {
      setOpen(detail, false);
    });
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(bind);
  }

  if (!window.__vtDesktopNavGlobals) {
    window.__vtDesktopNavGlobals = true;

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAll();
    });

    document.addEventListener('click', function (event) {
      if (!(event.target instanceof Element)) return;
      if (!event.target.closest('.vt-site-nav-wrap')) closeAll();
    });

    document.addEventListener('shopify:section:load', init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
